import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from 'react-redux';
import { loaderStateFalse, loaderStateTrue, setActiveLink } from '../../slices/mainSlice';
import TopTeams from "../Components/TopTeams";
import MatchList from "../Match/components/MatchList";
import { getPlayerListApi, getTeamListApi } from "../Team/TeamController";
import PrevArrow from "../Components/PrevArrow";
import NextArrow from "../Components/NextArrow";
import { getMatchListApi } from "../Match/MatchController";

const SponsorDashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);
  const { userDetails, token, userType } = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState("tab1");
  const [teamList, setTeamList] = useState([]);
  const [matchList, setMatchList] = useState([]);

  const tabs = [
    { id: "tab1", label: t('allGame') },
    { id: "tab2", label: t('liveGame') },
    { id: "tab3", label: t('preMatch') },
  ];

  useEffect(() => {
    // dispatch(setActiveLink("dashboard"))
    getTeamList();
    getMatchList();
  }, [])

  const getTeamList = () => {
    try {
      dispatch(loaderStateTrue());
      getTeamListApi()
        .then((response) => {
          let responseData = response.data?.result || [];
          console.log("responseDataresponseDataresponseData", responseData)
          setTeamList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  const getMatchList = () => {
    try {
      dispatch(loaderStateTrue());
      getMatchListApi()
        .then((response) => {
          let responseData = response.data?.result || [];
          console.log("responseDataresponseDataresponseData", responseData)
          setMatchList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };


  // Table list
  const matches = [
    {
      time: "12:30",
      date: "26 Aug",
      teams: [
        { name: "Paris Saint-Germain", logo: require("../../assets/images/clubs/paris.png") },
        { name: "Stade Brestois 29", logo: require("../../assets/images/clubs/sb29.png") }
      ],
      score: [2, 1],
      points: 2,
      chartIcon: "../../assets/images/icons/bar-chart.svg",
      rank: 24
    },
    {
      time: "14:00",
      date: "27 Aug",
      teams: [
        { name: "Racing Club de Lens", logo: require("../../assets/images/clubs/rcl.png") },
        { name: "Olympique Lyonnais", logo: require("../../assets/images/clubs/rfef.png") }
      ],
      score: [3, 1],
      points: 10,
      chartIcon: "../../assets/images/icons/bar-chart.svg",
      rank: 22
    }
  ];

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const upcomingMatches = [
    {
      date: "30 August 2025",
      time: "12:15",
      teams: [
        { name: "france", logo: require("../../assets/images/clubs/fff.png") },
        { name: "spain", logo: require("../../assets/images/clubs/rfef.png") }
      ],
      background: "/assets/images/curve-box.svg",
    },
    {
      date: "02 September 2025",
      time: "18:45",
      teams: [
        { name: "germany", logo: require("../../assets/images/clubs/rcl.png") },
        { name: "italy", logo: require("../../assets/images/clubs/sb29.png") }
      ],
      background: "/assets/images/curve-box.svg",
    }
  ];

  return (
    <>
      <main class="main p-4 relative">
        <div class="flex flex-col">
          <div class="flex flex-wrap items-start gap-y-6 -mx-2">
            <div class="lg:w-4/6 w-full px-2">
              <div class="space-y-5">
                <div class="relative text-white">
                  <div class="rounded-xl absolute inset-0 bg-gradient-to-b from-[#1B3594] to-[#1A215A] overflow-hidden">
                  </div>
                  <div class="relative bg-[url('../public/assets/images/club-bg.png')] bg-cover bg-no-repeat bg-center h-full">
                    <div class="flex max-sm:flex-wrap gap-y-3">
                      <div class="p-5 flex flex-col items-start justify-between [&_h1_strong]:text-primary-500 space-y-3 md:w-1/2 [&_strong]:text-primary-500">
                        <div class="flex max-sm:flex-wrap items-center gap-3">
                          <ul class="flex -space-x-4 rtl:space-x-reverse">
                            <li class="p-1.5 size-14 flex justify-center items-center border-4 border-[#1B3594] rounded-full bg-white">
                              <img class="size-7 object-contain dark:border-gray-800" src={require("../../assets/images/clubs/paris.png")} alt="" />
                            </li>
                            <li class="p-1.5 size-14 flex justify-center items-center border-4 border-[#1B3594] rounded-full bg-white">
                              <img class="size-7 object-contain dark:border-gray-800" src={require("../../assets/images/clubs/sb29.png")} alt="" />
                            </li>
                          </ul>
                          <div>
                            <h3 class="text-base font-bold uppercase">Paris Saint-Germain FC Stade Brestois 29</h3>
                          </div>
                        </div>
                        <div class="space-y-2">
                          <img src={require("../../assets/images/league1m.png")} alt="" />

                          <h4 class="lg:text-2xl md:text-xl text-lg font-bold uppercase">Paris Saint-Germain FC</h4>

                          <ul class="flex flex-wrap gap-1">
                            <li class="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                              <span class="opacity-50">1 x</span> 5.50
                            </li>
                            <li class="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                              <span class="opacity-50">x</span> 3.25
                            </li>
                            <li class="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                              <span class="opacity-50">2 x</span> 2.13
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="lg:-mt-4 text-center">
                        <img src={require("../../assets/images/france-teams.png")} alt="" class="w-full inline-block" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex items-center gap-3">
                  <h3 class="xl:text-2xl text-xl font-extrabold uppercase">{t('league1Ranking')}</h3>
                  <select class="form-select font-bold !max-w-[200px]">
                    <option value="">{t('season')} 2025/25</option>
                    <option value="">{t('season')} 2025/25</option>
                  </select>
                  <button class="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
                </div>
                <div class="">
                  <ul class="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
                    {tabs.map((tab) => (
                      <li
                        key={tab.id}
                        className={`nav-item ${activeTab === tab.id
                          ? "active"
                          : ""
                          }`}
                        onClick={() => setActiveTab(tab.id)}
                      >
                        <button>{tab.label}</button>
                      </li>
                    ))}
                  </ul>
                  <div className="tab-content space-y-4">
                    {activeTab === "tab1" && (
                      <div className="tab-pane">
                        <MatchList matchList={matchList} />
                      </div>
                    )}
                    {activeTab === "tab2" && (
                      <MatchList matchList={matchList} />
                    )}
                    {activeTab === "tab3" && (
                      <MatchList matchList={matchList} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
              <TopTeams tableName={"topTeam"} teamList={teamList} />
              <div class="panel space-y-3">
                <div class="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                  <div class="flex justify-center gap-3 w-full">
                    {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button> */}
                    <h3 class="xl:text-lg text-base font-extrabold uppercase">{t('currentlyPlaying')}</h3>
                    {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button> */}
                  </div>
                </div>
                <div class="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
                  <Slider {...settings}>
                    {upcomingMatches.map((match, index) => (
                      <div
                        key={index}
                        className="bg-no-repeat relative bg-[length:100%_auto]"
                        style={{ backgroundImage: `url(${match.background})` }}
                      >
                        <div className="p-5 text-center relative space-y-3">

                          {/* Date */}
                          <h4 className="text-lg font-bold text-gray-400 uppercase">
                            {match.date}
                          </h4>

                          <div className="flex justify-between items-center gap-4 w-full">

                            {/* Team 1 Logo */}
                            <div className="flex-none w-16">
                              <img
                                src={match.teams[0].logo}
                                alt={match.teams[0].name}
                                className="h-24 object-contain"
                              />
                            </div>

                            {/* Time */}
                            <div className="flex-1 font-secondary text-4xl font-black">
                              {match.time}
                            </div>

                            {/* Team 2 Logo */}
                            <div className="flex-none w-16">
                              <img
                                src={match.teams[1].logo}
                                alt={match.teams[1].name}
                                className="h-24 object-contain"
                              />
                            </div>

                          </div>
                        </div>

                        {/* Team Names */}
                        <div className="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                          <div className="font-secondary text-lg font-bold uppercase">
                            {t(match.teams[0].name)}
                          </div>
                          <div className="font-secondary text-lg font-bold uppercase">
                            {t(match.teams[1].name)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default SponsorDashboard;
